import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/HostelApplicationStatusList/GetGroupWithPaging",
    method: "get",
    params
  });
}
